/*
 * @Description: 
 * @Author: knx-xc
 * @LastEditTime: 2020-07-31 23:54:43
 * @LastEditors: knx-xc
 */
import http from '../http';
/**
 * @description:  首页 - 今日pv uv  总pv uv
 * @params ：  
 */

export var index_PV_UV = function index_PV_UV() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: '/manage/index/getTotalUp',
    data: data
  };
  return http(params);
};
/**
 * @description:  首页 - 渠道列表
 * @params ：  
 */

export var index_channel_list = function index_channel_list() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: '/manage/index/getChannelList',
    data: data
  };
  return http(params);
};
/**
 * @description:  首页 统计折线图 
 * @params ：  
 */

export var index_line_data = function index_line_data() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: '/manage/index/getBrokenLineData',
    data: data,
    formData: true
  };
  return http(params);
};